import React from 'react';
import { useNetwork } from '../context/NetworkContext';
import '../styles/network-status.css';

function NetworkStatus() {
  const { isOnline, networkQuality, pendingOperations } = useNetwork();

  if (isOnline && pendingOperations.length === 0) {
    return null;
  }

  const getStatusMessage = () => {
    if (!isOnline) return 'You are offline';
    if (pendingOperations.length > 0) return `${pendingOperations.length} pending operations`;
    switch (networkQuality) {
      case 'poor': return 'Poor network connection';
      case 'fair': return 'Fair network connection';
      default: return 'Network issues detected';
    }
  };

  const getStatusClass = () => {
    if (!isOnline) return 'offline';
    if (pendingOperations.length > 0) return 'pending';
    return networkQuality;
  };

  return (
    <div className={`network-status ${getStatusClass()}`}>
      <div className="network-status-content">
        <span className="network-status-icon">
          {!isOnline ? '📡' : networkQuality === 'poor' ? '⚠️' : '📶'}
        </span>
        <span className="network-status-message">{getStatusMessage()}</span>
      </div>
    </div>
  );
}

export default NetworkStatus;